/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R403RouteImport } from './routes/403'
import { Route as R404RouteImport } from './routes/404'
import { Route as R500RouteImport } from './routes/500'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as ProtectedAiChatRouteImport } from './routes/_protected/ai-chat'
import { Route as ProtectedAssessmentRouteImport } from './routes/_protected/assessment'
import { Route as ProtectedHomeRouteImport } from './routes/_protected/home'
import { Route as ProtectedMasterRouteImport } from './routes/_protected/master'
import { Route as ProtectedPlanUsageRouteImport } from './routes/_protected/plan-usage'
import { Route as ProtectedAiChatIndexRouteImport } from './routes/_protected/ai-chat/index'
import { Route as ProtectedAssessmentIndexRouteImport } from './routes/_protected/assessment/index'
import { Route as ProtectedAssessmentCreateRouteImport } from './routes/_protected/assessment/create'
import { Route as ProtectedDatConversionIndexRouteImport } from './routes/_protected/dat-conversion/index'
import { Route as ProtectedDataImportIndexRouteImport } from './routes/_protected/data-import/index'
import { Route as ProtectedDataImportUploadRouteImport } from './routes/_protected/data-import/upload'
import { Route as ProtectedInquiryIndexRouteImport } from './routes/_protected/inquiry/index'
import { Route as ProtectedInquiryCompletedRouteImport } from './routes/_protected/inquiry/completed'
import { Route as ProtectedJobIndexRouteImport } from './routes/_protected/job/index'
import { Route as ProtectedJobJobIdRouteImport } from './routes/_protected/job/$jobId'
import { Route as ProtectedMasterIndexRouteImport } from './routes/_protected/master/index'
import { Route as ProtectedMasterAccountingTypesRouteImport } from './routes/_protected/master/accounting-types'
import { Route as ProtectedMasterExpenditureItemsRouteImport } from './routes/_protected/master/expenditure-items'
import { Route as ProtectedMasterOrganizationsRouteImport } from './routes/_protected/master/organizations'
import { Route as ProtectedProjectsIndexRouteImport } from './routes/_protected/projects/index'
import { Route as ProtectedProjectsAiMatchingResultsRouteImport } from './routes/_protected/projects/ai-matching-results'
import { Route as ProtectedProjectsCreateRouteImport } from './routes/_protected/projects/create'
import { Route as ProtectedSettlementStatisticsConverterIndexRouteImport } from './routes/_protected/settlement-statistics-converter/index'
import { Route as ProtectedSettlementStatisticsConverterCreateRouteImport } from './routes/_protected/settlement-statistics-converter/create'
import { Route as ProtectedUsersIndexRouteImport } from './routes/_protected/users/index'
import { Route as ProtectedAiChatChatIndexRouteImport } from './routes/_protected/ai-chat/chat/index'
import { Route as ProtectedAssessmentAssessmentIdIndexRouteImport } from './routes/_protected/assessment/$assessmentId/index'
import { Route as ProtectedAssessmentAssessmentIdDiffRouteImport } from './routes/_protected/assessment/$assessmentId/diff'
import { Route as ProtectedDataImportImportIdIndexRouteImport } from './routes/_protected/data-import/$importId/index'
import { Route as ProtectedProjectsProjectIdIndexRouteImport } from './routes/_protected/projects/$projectId/index'
import { Route as ProtectedProjectsProjectIdEditRouteImport } from './routes/_protected/projects/$projectId/edit'
import { Route as ProtectedProjectsProjectIdMemoRouteImport } from './routes/_protected/projects/$projectId/memo'
import { Route as ProtectedProjectsAiMatchingResultsIndexRouteImport } from './routes/_protected/projects/ai-matching-results/index'
import { Route as ProtectedSettlementStatisticsConverterResultIdIndexRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/index'
import { Route as ProtectedSettlementStatisticsConverterResultIdAnalysisRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/analysis'
import { Route as ProtectedSettlementStatisticsConverterResultIdExpenditureRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/expenditure'
import { Route as ProtectedSettlementStatisticsConverterResultIdRevenueRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/revenue'
import { Route as ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
import { Route as ProtectedAiChatChatThreadIdIndexRouteImport } from './routes/_protected/ai-chat/chat/$threadId/index'
import { Route as ProtectedAssessmentAssessmentIdOverviewIndexRouteImport } from './routes/_protected/assessment/$assessmentId/overview/index'
import { Route as ProtectedAssessmentAssessmentIdOverviewEditRouteImport } from './routes/_protected/assessment/$assessmentId/overview/edit'
import { Route as ProtectedProjectsAiMatchingResultsNationalGrantsIndexRouteImport } from './routes/_protected/projects/ai-matching-results/national-grants/index'
import { Route as ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRouteImport } from './routes/_protected/projects/ai-matching-results/prefectural-grants/index'
import { Route as ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRouteImport } from './routes/_protected/projects/ai-matching-results/special-allocation-tax-survey/index'
import { Route as ProtectedSettlementStatisticsConverterResultIdMasterIndexRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/master/index'
import { Route as ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature'
import { Route as ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRouteImport } from './routes/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose'
import { Route as ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRouteImport } from './routes/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId'
import { Route as ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRouteImport } from './routes/_protected/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
import { Route as ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRouteImport } from './routes/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R500Route = R500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedAiChatRoute = ProtectedAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAssessmentRoute = ProtectedAssessmentRouteImport.update({
  id: '/assessment',
  path: '/assessment',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHomeRoute = ProtectedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedMasterRoute = ProtectedMasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPlanUsageRoute = ProtectedPlanUsageRouteImport.update({
  id: '/plan-usage',
  path: '/plan-usage',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAiChatIndexRoute = ProtectedAiChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAiChatRoute,
} as any)
const ProtectedAssessmentIndexRoute =
  ProtectedAssessmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedAssessmentCreateRoute =
  ProtectedAssessmentCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedDatConversionIndexRoute =
  ProtectedDatConversionIndexRouteImport.update({
    id: '/dat-conversion/',
    path: '/dat-conversion/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDataImportIndexRoute =
  ProtectedDataImportIndexRouteImport.update({
    id: '/data-import/',
    path: '/data-import/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDataImportUploadRoute =
  ProtectedDataImportUploadRouteImport.update({
    id: '/data-import/upload',
    path: '/data-import/upload',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedInquiryIndexRoute = ProtectedInquiryIndexRouteImport.update({
  id: '/inquiry/',
  path: '/inquiry/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedInquiryCompletedRoute =
  ProtectedInquiryCompletedRouteImport.update({
    id: '/inquiry/completed',
    path: '/inquiry/completed',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedJobIndexRoute = ProtectedJobIndexRouteImport.update({
  id: '/job/',
  path: '/job/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedJobJobIdRoute = ProtectedJobJobIdRouteImport.update({
  id: '/job/$jobId',
  path: '/job/$jobId',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedMasterIndexRoute = ProtectedMasterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedMasterRoute,
} as any)
const ProtectedMasterAccountingTypesRoute =
  ProtectedMasterAccountingTypesRouteImport.update({
    id: '/accounting-types',
    path: '/accounting-types',
    getParentRoute: () => ProtectedMasterRoute,
  } as any)
const ProtectedMasterExpenditureItemsRoute =
  ProtectedMasterExpenditureItemsRouteImport.update({
    id: '/expenditure-items',
    path: '/expenditure-items',
    getParentRoute: () => ProtectedMasterRoute,
  } as any)
const ProtectedMasterOrganizationsRoute =
  ProtectedMasterOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => ProtectedMasterRoute,
  } as any)
const ProtectedProjectsIndexRoute = ProtectedProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProjectsAiMatchingResultsRoute =
  ProtectedProjectsAiMatchingResultsRouteImport.update({
    id: '/projects/ai-matching-results',
    path: '/projects/ai-matching-results',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsCreateRoute = ProtectedProjectsCreateRouteImport.update({
  id: '/projects/create',
  path: '/projects/create',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSettlementStatisticsConverterIndexRoute =
  ProtectedSettlementStatisticsConverterIndexRouteImport.update({
    id: '/settlement-statistics-converter/',
    path: '/settlement-statistics-converter/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterCreateRoute =
  ProtectedSettlementStatisticsConverterCreateRouteImport.update({
    id: '/settlement-statistics-converter/create',
    path: '/settlement-statistics-converter/create',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedUsersIndexRoute = ProtectedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAiChatChatIndexRoute =
  ProtectedAiChatChatIndexRouteImport.update({
    id: '/chat/',
    path: '/chat/',
    getParentRoute: () => ProtectedAiChatRoute,
  } as any)
const ProtectedAssessmentAssessmentIdIndexRoute =
  ProtectedAssessmentAssessmentIdIndexRouteImport.update({
    id: '/$assessmentId/',
    path: '/$assessmentId/',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedAssessmentAssessmentIdDiffRoute =
  ProtectedAssessmentAssessmentIdDiffRouteImport.update({
    id: '/$assessmentId/diff',
    path: '/$assessmentId/diff',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedDataImportImportIdIndexRoute =
  ProtectedDataImportImportIdIndexRouteImport.update({
    id: '/data-import/$importId/',
    path: '/data-import/$importId/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsProjectIdIndexRoute =
  ProtectedProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsProjectIdEditRoute =
  ProtectedProjectsProjectIdEditRouteImport.update({
    id: '/projects/$projectId/edit',
    path: '/projects/$projectId/edit',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsProjectIdMemoRoute =
  ProtectedProjectsProjectIdMemoRouteImport.update({
    id: '/projects/$projectId/memo',
    path: '/projects/$projectId/memo',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsAiMatchingResultsIndexRoute =
  ProtectedProjectsAiMatchingResultsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdIndexRoute =
  ProtectedSettlementStatisticsConverterResultIdIndexRouteImport.update({
    id: '/settlement-statistics-converter/$resultId/',
    path: '/settlement-statistics-converter/$resultId/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdAnalysisRoute =
  ProtectedSettlementStatisticsConverterResultIdAnalysisRouteImport.update({
    id: '/settlement-statistics-converter/$resultId/analysis',
    path: '/settlement-statistics-converter/$resultId/analysis',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdExpenditureRoute =
  ProtectedSettlementStatisticsConverterResultIdExpenditureRouteImport.update({
    id: '/settlement-statistics-converter/$resultId/expenditure',
    path: '/settlement-statistics-converter/$resultId/expenditure',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdRevenueRoute =
  ProtectedSettlementStatisticsConverterResultIdRevenueRouteImport.update({
    id: '/settlement-statistics-converter/$resultId/revenue',
    path: '/settlement-statistics-converter/$resultId/revenue',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute =
  ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRouteImport.update(
    {
      id: '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation',
      path: '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation',
      getParentRoute: () => ProtectedRoute,
    } as any,
  )
const ProtectedAiChatChatThreadIdIndexRoute =
  ProtectedAiChatChatThreadIdIndexRouteImport.update({
    id: '/chat/$threadId/',
    path: '/chat/$threadId/',
    getParentRoute: () => ProtectedAiChatRoute,
  } as any)
const ProtectedAssessmentAssessmentIdOverviewIndexRoute =
  ProtectedAssessmentAssessmentIdOverviewIndexRouteImport.update({
    id: '/$assessmentId/overview/',
    path: '/$assessmentId/overview/',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedAssessmentAssessmentIdOverviewEditRoute =
  ProtectedAssessmentAssessmentIdOverviewEditRouteImport.update({
    id: '/$assessmentId/overview/edit',
    path: '/$assessmentId/overview/edit',
    getParentRoute: () => ProtectedAssessmentRoute,
  } as any)
const ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute =
  ProtectedProjectsAiMatchingResultsNationalGrantsIndexRouteImport.update({
    id: '/national-grants/',
    path: '/national-grants/',
    getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
  } as any)
const ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute =
  ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRouteImport.update({
    id: '/prefectural-grants/',
    path: '/prefectural-grants/',
    getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
  } as any)
const ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute =
  ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRouteImport.update(
    {
      id: '/special-allocation-tax-survey/',
      path: '/special-allocation-tax-survey/',
      getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
    } as any,
  )
const ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute =
  ProtectedSettlementStatisticsConverterResultIdMasterIndexRouteImport.update({
    id: '/settlement-statistics-converter/$resultId/master/',
    path: '/settlement-statistics-converter/$resultId/master/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute =
  ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRouteImport.update(
    {
      id: '/settlement-statistics-converter/$resultId/master/expenditure_nature',
      path: '/settlement-statistics-converter/$resultId/master/expenditure_nature',
      getParentRoute: () => ProtectedRoute,
    } as any,
  )
const ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute =
  ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRouteImport.update(
    {
      id: '/settlement-statistics-converter/$resultId/master/revenue_purpose',
      path: '/settlement-statistics-converter/$resultId/master/revenue_purpose',
      getParentRoute: () => ProtectedRoute,
    } as any,
  )
const ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute =
  ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRouteImport.update(
    {
      id: '/national-grants/$documentId/$recordId',
      path: '/national-grants/$documentId/$recordId',
      getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
    } as any,
  )
const ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute =
  ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRouteImport.update(
    {
      id: '/prefectural-grants/$documentId/$recordId',
      path: '/prefectural-grants/$documentId/$recordId',
      getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
    } as any,
  )
const ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute =
  ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRouteImport.update(
    {
      id: '/special-allocation-tax-survey/$documentId/$recordId',
      path: '/special-allocation-tax-survey/$documentId/$recordId',
      getParentRoute: () => ProtectedProjectsAiMatchingResultsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/ai-chat': typeof ProtectedAiChatRouteWithChildren
  '/assessment': typeof ProtectedAssessmentRouteWithChildren
  '/home': typeof ProtectedHomeRoute
  '/master': typeof ProtectedMasterRouteWithChildren
  '/plan-usage': typeof ProtectedPlanUsageRoute
  '/assessment/create': typeof ProtectedAssessmentCreateRoute
  '/data-import/upload': typeof ProtectedDataImportUploadRoute
  '/inquiry/completed': typeof ProtectedInquiryCompletedRoute
  '/job/$jobId': typeof ProtectedJobJobIdRoute
  '/master/accounting-types': typeof ProtectedMasterAccountingTypesRoute
  '/master/expenditure-items': typeof ProtectedMasterExpenditureItemsRoute
  '/master/organizations': typeof ProtectedMasterOrganizationsRoute
  '/projects/ai-matching-results': typeof ProtectedProjectsAiMatchingResultsRouteWithChildren
  '/projects/create': typeof ProtectedProjectsCreateRoute
  '/settlement-statistics-converter/create': typeof ProtectedSettlementStatisticsConverterCreateRoute
  '/ai-chat/': typeof ProtectedAiChatIndexRoute
  '/assessment/': typeof ProtectedAssessmentIndexRoute
  '/dat-conversion/': typeof ProtectedDatConversionIndexRoute
  '/data-import/': typeof ProtectedDataImportIndexRoute
  '/inquiry/': typeof ProtectedInquiryIndexRoute
  '/job/': typeof ProtectedJobIndexRoute
  '/master/': typeof ProtectedMasterIndexRoute
  '/projects/': typeof ProtectedProjectsIndexRoute
  '/settlement-statistics-converter/': typeof ProtectedSettlementStatisticsConverterIndexRoute
  '/users/': typeof ProtectedUsersIndexRoute
  '/assessment/$assessmentId/diff': typeof ProtectedAssessmentAssessmentIdDiffRoute
  '/projects/$projectId/edit': typeof ProtectedProjectsProjectIdEditRoute
  '/projects/$projectId/memo': typeof ProtectedProjectsProjectIdMemoRoute
  '/settlement-statistics-converter/$resultId/analysis': typeof ProtectedSettlementStatisticsConverterResultIdAnalysisRoute
  '/settlement-statistics-converter/$resultId/expenditure': typeof ProtectedSettlementStatisticsConverterResultIdExpenditureRoute
  '/settlement-statistics-converter/$resultId/revenue': typeof ProtectedSettlementStatisticsConverterResultIdRevenueRoute
  '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation': typeof ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute
  '/ai-chat/chat/': typeof ProtectedAiChatChatIndexRoute
  '/assessment/$assessmentId/': typeof ProtectedAssessmentAssessmentIdIndexRoute
  '/data-import/$importId/': typeof ProtectedDataImportImportIdIndexRoute
  '/projects/$projectId/': typeof ProtectedProjectsProjectIdIndexRoute
  '/projects/ai-matching-results/': typeof ProtectedProjectsAiMatchingResultsIndexRoute
  '/settlement-statistics-converter/$resultId/': typeof ProtectedSettlementStatisticsConverterResultIdIndexRoute
  '/assessment/$assessmentId/overview/edit': typeof ProtectedAssessmentAssessmentIdOverviewEditRoute
  '/settlement-statistics-converter/$resultId/master/expenditure_nature': typeof ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute
  '/settlement-statistics-converter/$resultId/master/revenue_purpose': typeof ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute
  '/ai-chat/chat/$threadId/': typeof ProtectedAiChatChatThreadIdIndexRoute
  '/assessment/$assessmentId/overview/': typeof ProtectedAssessmentAssessmentIdOverviewIndexRoute
  '/projects/ai-matching-results/national-grants/': typeof ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute
  '/projects/ai-matching-results/prefectural-grants/': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute
  '/projects/ai-matching-results/special-allocation-tax-survey/': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute
  '/settlement-statistics-converter/$resultId/master/': typeof ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute
  '/projects/ai-matching-results/national-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute
  '/projects/ai-matching-results/prefectural-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute
  '/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/home': typeof ProtectedHomeRoute
  '/plan-usage': typeof ProtectedPlanUsageRoute
  '/assessment/create': typeof ProtectedAssessmentCreateRoute
  '/data-import/upload': typeof ProtectedDataImportUploadRoute
  '/inquiry/completed': typeof ProtectedInquiryCompletedRoute
  '/job/$jobId': typeof ProtectedJobJobIdRoute
  '/master/accounting-types': typeof ProtectedMasterAccountingTypesRoute
  '/master/expenditure-items': typeof ProtectedMasterExpenditureItemsRoute
  '/master/organizations': typeof ProtectedMasterOrganizationsRoute
  '/projects/create': typeof ProtectedProjectsCreateRoute
  '/settlement-statistics-converter/create': typeof ProtectedSettlementStatisticsConverterCreateRoute
  '/ai-chat': typeof ProtectedAiChatIndexRoute
  '/assessment': typeof ProtectedAssessmentIndexRoute
  '/dat-conversion': typeof ProtectedDatConversionIndexRoute
  '/data-import': typeof ProtectedDataImportIndexRoute
  '/inquiry': typeof ProtectedInquiryIndexRoute
  '/job': typeof ProtectedJobIndexRoute
  '/master': typeof ProtectedMasterIndexRoute
  '/projects': typeof ProtectedProjectsIndexRoute
  '/settlement-statistics-converter': typeof ProtectedSettlementStatisticsConverterIndexRoute
  '/users': typeof ProtectedUsersIndexRoute
  '/assessment/$assessmentId/diff': typeof ProtectedAssessmentAssessmentIdDiffRoute
  '/projects/$projectId/edit': typeof ProtectedProjectsProjectIdEditRoute
  '/projects/$projectId/memo': typeof ProtectedProjectsProjectIdMemoRoute
  '/settlement-statistics-converter/$resultId/analysis': typeof ProtectedSettlementStatisticsConverterResultIdAnalysisRoute
  '/settlement-statistics-converter/$resultId/expenditure': typeof ProtectedSettlementStatisticsConverterResultIdExpenditureRoute
  '/settlement-statistics-converter/$resultId/revenue': typeof ProtectedSettlementStatisticsConverterResultIdRevenueRoute
  '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation': typeof ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute
  '/ai-chat/chat': typeof ProtectedAiChatChatIndexRoute
  '/assessment/$assessmentId': typeof ProtectedAssessmentAssessmentIdIndexRoute
  '/data-import/$importId': typeof ProtectedDataImportImportIdIndexRoute
  '/projects/$projectId': typeof ProtectedProjectsProjectIdIndexRoute
  '/projects/ai-matching-results': typeof ProtectedProjectsAiMatchingResultsIndexRoute
  '/settlement-statistics-converter/$resultId': typeof ProtectedSettlementStatisticsConverterResultIdIndexRoute
  '/assessment/$assessmentId/overview/edit': typeof ProtectedAssessmentAssessmentIdOverviewEditRoute
  '/settlement-statistics-converter/$resultId/master/expenditure_nature': typeof ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute
  '/settlement-statistics-converter/$resultId/master/revenue_purpose': typeof ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute
  '/ai-chat/chat/$threadId': typeof ProtectedAiChatChatThreadIdIndexRoute
  '/assessment/$assessmentId/overview': typeof ProtectedAssessmentAssessmentIdOverviewIndexRoute
  '/projects/ai-matching-results/national-grants': typeof ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute
  '/projects/ai-matching-results/prefectural-grants': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute
  '/projects/ai-matching-results/special-allocation-tax-survey': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute
  '/settlement-statistics-converter/$resultId/master': typeof ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute
  '/projects/ai-matching-results/national-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute
  '/projects/ai-matching-results/prefectural-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute
  '/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/_protected': typeof ProtectedRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/_protected/ai-chat': typeof ProtectedAiChatRouteWithChildren
  '/_protected/assessment': typeof ProtectedAssessmentRouteWithChildren
  '/_protected/home': typeof ProtectedHomeRoute
  '/_protected/master': typeof ProtectedMasterRouteWithChildren
  '/_protected/plan-usage': typeof ProtectedPlanUsageRoute
  '/_protected/assessment/create': typeof ProtectedAssessmentCreateRoute
  '/_protected/data-import/upload': typeof ProtectedDataImportUploadRoute
  '/_protected/inquiry/completed': typeof ProtectedInquiryCompletedRoute
  '/_protected/job/$jobId': typeof ProtectedJobJobIdRoute
  '/_protected/master/accounting-types': typeof ProtectedMasterAccountingTypesRoute
  '/_protected/master/expenditure-items': typeof ProtectedMasterExpenditureItemsRoute
  '/_protected/master/organizations': typeof ProtectedMasterOrganizationsRoute
  '/_protected/projects/ai-matching-results': typeof ProtectedProjectsAiMatchingResultsRouteWithChildren
  '/_protected/projects/create': typeof ProtectedProjectsCreateRoute
  '/_protected/settlement-statistics-converter/create': typeof ProtectedSettlementStatisticsConverterCreateRoute
  '/_protected/ai-chat/': typeof ProtectedAiChatIndexRoute
  '/_protected/assessment/': typeof ProtectedAssessmentIndexRoute
  '/_protected/dat-conversion/': typeof ProtectedDatConversionIndexRoute
  '/_protected/data-import/': typeof ProtectedDataImportIndexRoute
  '/_protected/inquiry/': typeof ProtectedInquiryIndexRoute
  '/_protected/job/': typeof ProtectedJobIndexRoute
  '/_protected/master/': typeof ProtectedMasterIndexRoute
  '/_protected/projects/': typeof ProtectedProjectsIndexRoute
  '/_protected/settlement-statistics-converter/': typeof ProtectedSettlementStatisticsConverterIndexRoute
  '/_protected/users/': typeof ProtectedUsersIndexRoute
  '/_protected/assessment/$assessmentId/diff': typeof ProtectedAssessmentAssessmentIdDiffRoute
  '/_protected/projects/$projectId/edit': typeof ProtectedProjectsProjectIdEditRoute
  '/_protected/projects/$projectId/memo': typeof ProtectedProjectsProjectIdMemoRoute
  '/_protected/settlement-statistics-converter/$resultId/analysis': typeof ProtectedSettlementStatisticsConverterResultIdAnalysisRoute
  '/_protected/settlement-statistics-converter/$resultId/expenditure': typeof ProtectedSettlementStatisticsConverterResultIdExpenditureRoute
  '/_protected/settlement-statistics-converter/$resultId/revenue': typeof ProtectedSettlementStatisticsConverterResultIdRevenueRoute
  '/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation': typeof ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute
  '/_protected/ai-chat/chat/': typeof ProtectedAiChatChatIndexRoute
  '/_protected/assessment/$assessmentId/': typeof ProtectedAssessmentAssessmentIdIndexRoute
  '/_protected/data-import/$importId/': typeof ProtectedDataImportImportIdIndexRoute
  '/_protected/projects/$projectId/': typeof ProtectedProjectsProjectIdIndexRoute
  '/_protected/projects/ai-matching-results/': typeof ProtectedProjectsAiMatchingResultsIndexRoute
  '/_protected/settlement-statistics-converter/$resultId/': typeof ProtectedSettlementStatisticsConverterResultIdIndexRoute
  '/_protected/assessment/$assessmentId/overview/edit': typeof ProtectedAssessmentAssessmentIdOverviewEditRoute
  '/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature': typeof ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute
  '/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose': typeof ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute
  '/_protected/ai-chat/chat/$threadId/': typeof ProtectedAiChatChatThreadIdIndexRoute
  '/_protected/assessment/$assessmentId/overview/': typeof ProtectedAssessmentAssessmentIdOverviewIndexRoute
  '/_protected/projects/ai-matching-results/national-grants/': typeof ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute
  '/_protected/projects/ai-matching-results/prefectural-grants/': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute
  '/_protected/projects/ai-matching-results/special-allocation-tax-survey/': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute
  '/_protected/settlement-statistics-converter/$resultId/master/': typeof ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute
  '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute
  '/_protected/projects/ai-matching-results/prefectural-grants/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute
  '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId': typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/404'
    | '/500'
    | '/change-password'
    | '/login'
    | '/password-reset'
    | '/ai-chat'
    | '/assessment'
    | '/home'
    | '/master'
    | '/plan-usage'
    | '/assessment/create'
    | '/data-import/upload'
    | '/inquiry/completed'
    | '/job/$jobId'
    | '/master/accounting-types'
    | '/master/expenditure-items'
    | '/master/organizations'
    | '/projects/ai-matching-results'
    | '/projects/create'
    | '/settlement-statistics-converter/create'
    | '/ai-chat/'
    | '/assessment/'
    | '/dat-conversion/'
    | '/data-import/'
    | '/inquiry/'
    | '/job/'
    | '/master/'
    | '/projects/'
    | '/settlement-statistics-converter/'
    | '/users/'
    | '/assessment/$assessmentId/diff'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/memo'
    | '/settlement-statistics-converter/$resultId/analysis'
    | '/settlement-statistics-converter/$resultId/expenditure'
    | '/settlement-statistics-converter/$resultId/revenue'
    | '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
    | '/ai-chat/chat/'
    | '/assessment/$assessmentId/'
    | '/data-import/$importId/'
    | '/projects/$projectId/'
    | '/projects/ai-matching-results/'
    | '/settlement-statistics-converter/$resultId/'
    | '/assessment/$assessmentId/overview/edit'
    | '/settlement-statistics-converter/$resultId/master/expenditure_nature'
    | '/settlement-statistics-converter/$resultId/master/revenue_purpose'
    | '/ai-chat/chat/$threadId/'
    | '/assessment/$assessmentId/overview/'
    | '/projects/ai-matching-results/national-grants/'
    | '/projects/ai-matching-results/prefectural-grants/'
    | '/projects/ai-matching-results/special-allocation-tax-survey/'
    | '/settlement-statistics-converter/$resultId/master/'
    | '/projects/ai-matching-results/national-grants/$documentId/$recordId'
    | '/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
    | '/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/404'
    | '/500'
    | '/change-password'
    | '/login'
    | '/password-reset'
    | '/home'
    | '/plan-usage'
    | '/assessment/create'
    | '/data-import/upload'
    | '/inquiry/completed'
    | '/job/$jobId'
    | '/master/accounting-types'
    | '/master/expenditure-items'
    | '/master/organizations'
    | '/projects/create'
    | '/settlement-statistics-converter/create'
    | '/ai-chat'
    | '/assessment'
    | '/dat-conversion'
    | '/data-import'
    | '/inquiry'
    | '/job'
    | '/master'
    | '/projects'
    | '/settlement-statistics-converter'
    | '/users'
    | '/assessment/$assessmentId/diff'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/memo'
    | '/settlement-statistics-converter/$resultId/analysis'
    | '/settlement-statistics-converter/$resultId/expenditure'
    | '/settlement-statistics-converter/$resultId/revenue'
    | '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
    | '/ai-chat/chat'
    | '/assessment/$assessmentId'
    | '/data-import/$importId'
    | '/projects/$projectId'
    | '/projects/ai-matching-results'
    | '/settlement-statistics-converter/$resultId'
    | '/assessment/$assessmentId/overview/edit'
    | '/settlement-statistics-converter/$resultId/master/expenditure_nature'
    | '/settlement-statistics-converter/$resultId/master/revenue_purpose'
    | '/ai-chat/chat/$threadId'
    | '/assessment/$assessmentId/overview'
    | '/projects/ai-matching-results/national-grants'
    | '/projects/ai-matching-results/prefectural-grants'
    | '/projects/ai-matching-results/special-allocation-tax-survey'
    | '/settlement-statistics-converter/$resultId/master'
    | '/projects/ai-matching-results/national-grants/$documentId/$recordId'
    | '/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
    | '/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/404'
    | '/500'
    | '/_protected'
    | '/change-password'
    | '/login'
    | '/password-reset'
    | '/_protected/ai-chat'
    | '/_protected/assessment'
    | '/_protected/home'
    | '/_protected/master'
    | '/_protected/plan-usage'
    | '/_protected/assessment/create'
    | '/_protected/data-import/upload'
    | '/_protected/inquiry/completed'
    | '/_protected/job/$jobId'
    | '/_protected/master/accounting-types'
    | '/_protected/master/expenditure-items'
    | '/_protected/master/organizations'
    | '/_protected/projects/ai-matching-results'
    | '/_protected/projects/create'
    | '/_protected/settlement-statistics-converter/create'
    | '/_protected/ai-chat/'
    | '/_protected/assessment/'
    | '/_protected/dat-conversion/'
    | '/_protected/data-import/'
    | '/_protected/inquiry/'
    | '/_protected/job/'
    | '/_protected/master/'
    | '/_protected/projects/'
    | '/_protected/settlement-statistics-converter/'
    | '/_protected/users/'
    | '/_protected/assessment/$assessmentId/diff'
    | '/_protected/projects/$projectId/edit'
    | '/_protected/projects/$projectId/memo'
    | '/_protected/settlement-statistics-converter/$resultId/analysis'
    | '/_protected/settlement-statistics-converter/$resultId/expenditure'
    | '/_protected/settlement-statistics-converter/$resultId/revenue'
    | '/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
    | '/_protected/ai-chat/chat/'
    | '/_protected/assessment/$assessmentId/'
    | '/_protected/data-import/$importId/'
    | '/_protected/projects/$projectId/'
    | '/_protected/projects/ai-matching-results/'
    | '/_protected/settlement-statistics-converter/$resultId/'
    | '/_protected/assessment/$assessmentId/overview/edit'
    | '/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature'
    | '/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose'
    | '/_protected/ai-chat/chat/$threadId/'
    | '/_protected/assessment/$assessmentId/overview/'
    | '/_protected/projects/ai-matching-results/national-grants/'
    | '/_protected/projects/ai-matching-results/prefectural-grants/'
    | '/_protected/projects/ai-matching-results/special-allocation-tax-survey/'
    | '/_protected/settlement-statistics-converter/$resultId/master/'
    | '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId'
    | '/_protected/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
    | '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  R500Route: typeof R500Route
  ProtectedRoute: typeof ProtectedRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
  PasswordResetRoute: typeof PasswordResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/500': {
      id: '/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof R500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/ai-chat': {
      id: '/_protected/ai-chat'
      path: '/ai-chat'
      fullPath: '/ai-chat'
      preLoaderRoute: typeof ProtectedAiChatRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/assessment': {
      id: '/_protected/assessment'
      path: '/assessment'
      fullPath: '/assessment'
      preLoaderRoute: typeof ProtectedAssessmentRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home': {
      id: '/_protected/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ProtectedHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/master': {
      id: '/_protected/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof ProtectedMasterRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/plan-usage': {
      id: '/_protected/plan-usage'
      path: '/plan-usage'
      fullPath: '/plan-usage'
      preLoaderRoute: typeof ProtectedPlanUsageRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ai-chat/': {
      id: '/_protected/ai-chat/'
      path: '/'
      fullPath: '/ai-chat/'
      preLoaderRoute: typeof ProtectedAiChatIndexRouteImport
      parentRoute: typeof ProtectedAiChatRoute
    }
    '/_protected/assessment/': {
      id: '/_protected/assessment/'
      path: '/'
      fullPath: '/assessment/'
      preLoaderRoute: typeof ProtectedAssessmentIndexRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/assessment/create': {
      id: '/_protected/assessment/create'
      path: '/create'
      fullPath: '/assessment/create'
      preLoaderRoute: typeof ProtectedAssessmentCreateRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/dat-conversion/': {
      id: '/_protected/dat-conversion/'
      path: '/dat-conversion'
      fullPath: '/dat-conversion/'
      preLoaderRoute: typeof ProtectedDatConversionIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/data-import/': {
      id: '/_protected/data-import/'
      path: '/data-import'
      fullPath: '/data-import/'
      preLoaderRoute: typeof ProtectedDataImportIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/data-import/upload': {
      id: '/_protected/data-import/upload'
      path: '/data-import/upload'
      fullPath: '/data-import/upload'
      preLoaderRoute: typeof ProtectedDataImportUploadRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/inquiry/': {
      id: '/_protected/inquiry/'
      path: '/inquiry'
      fullPath: '/inquiry/'
      preLoaderRoute: typeof ProtectedInquiryIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/inquiry/completed': {
      id: '/_protected/inquiry/completed'
      path: '/inquiry/completed'
      fullPath: '/inquiry/completed'
      preLoaderRoute: typeof ProtectedInquiryCompletedRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/job/': {
      id: '/_protected/job/'
      path: '/job'
      fullPath: '/job/'
      preLoaderRoute: typeof ProtectedJobIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/job/$jobId': {
      id: '/_protected/job/$jobId'
      path: '/job/$jobId'
      fullPath: '/job/$jobId'
      preLoaderRoute: typeof ProtectedJobJobIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/master/': {
      id: '/_protected/master/'
      path: '/'
      fullPath: '/master/'
      preLoaderRoute: typeof ProtectedMasterIndexRouteImport
      parentRoute: typeof ProtectedMasterRoute
    }
    '/_protected/master/accounting-types': {
      id: '/_protected/master/accounting-types'
      path: '/accounting-types'
      fullPath: '/master/accounting-types'
      preLoaderRoute: typeof ProtectedMasterAccountingTypesRouteImport
      parentRoute: typeof ProtectedMasterRoute
    }
    '/_protected/master/expenditure-items': {
      id: '/_protected/master/expenditure-items'
      path: '/expenditure-items'
      fullPath: '/master/expenditure-items'
      preLoaderRoute: typeof ProtectedMasterExpenditureItemsRouteImport
      parentRoute: typeof ProtectedMasterRoute
    }
    '/_protected/master/organizations': {
      id: '/_protected/master/organizations'
      path: '/organizations'
      fullPath: '/master/organizations'
      preLoaderRoute: typeof ProtectedMasterOrganizationsRouteImport
      parentRoute: typeof ProtectedMasterRoute
    }
    '/_protected/projects/': {
      id: '/_protected/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProtectedProjectsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/ai-matching-results': {
      id: '/_protected/projects/ai-matching-results'
      path: '/projects/ai-matching-results'
      fullPath: '/projects/ai-matching-results'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/create': {
      id: '/_protected/projects/create'
      path: '/projects/create'
      fullPath: '/projects/create'
      preLoaderRoute: typeof ProtectedProjectsCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/': {
      id: '/_protected/settlement-statistics-converter/'
      path: '/settlement-statistics-converter'
      fullPath: '/settlement-statistics-converter/'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/create': {
      id: '/_protected/settlement-statistics-converter/create'
      path: '/settlement-statistics-converter/create'
      fullPath: '/settlement-statistics-converter/create'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/users/': {
      id: '/_protected/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof ProtectedUsersIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ai-chat/chat/': {
      id: '/_protected/ai-chat/chat/'
      path: '/chat'
      fullPath: '/ai-chat/chat/'
      preLoaderRoute: typeof ProtectedAiChatChatIndexRouteImport
      parentRoute: typeof ProtectedAiChatRoute
    }
    '/_protected/assessment/$assessmentId/': {
      id: '/_protected/assessment/$assessmentId/'
      path: '/$assessmentId'
      fullPath: '/assessment/$assessmentId/'
      preLoaderRoute: typeof ProtectedAssessmentAssessmentIdIndexRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/assessment/$assessmentId/diff': {
      id: '/_protected/assessment/$assessmentId/diff'
      path: '/$assessmentId/diff'
      fullPath: '/assessment/$assessmentId/diff'
      preLoaderRoute: typeof ProtectedAssessmentAssessmentIdDiffRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/data-import/$importId/': {
      id: '/_protected/data-import/$importId/'
      path: '/data-import/$importId'
      fullPath: '/data-import/$importId/'
      preLoaderRoute: typeof ProtectedDataImportImportIdIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/$projectId/': {
      id: '/_protected/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProtectedProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/$projectId/edit': {
      id: '/_protected/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof ProtectedProjectsProjectIdEditRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/$projectId/memo': {
      id: '/_protected/projects/$projectId/memo'
      path: '/projects/$projectId/memo'
      fullPath: '/projects/$projectId/memo'
      preLoaderRoute: typeof ProtectedProjectsProjectIdMemoRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/ai-matching-results/': {
      id: '/_protected/projects/ai-matching-results/'
      path: '/'
      fullPath: '/projects/ai-matching-results/'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsIndexRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/': {
      id: '/_protected/settlement-statistics-converter/$resultId/'
      path: '/settlement-statistics-converter/$resultId'
      fullPath: '/settlement-statistics-converter/$resultId/'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/analysis': {
      id: '/_protected/settlement-statistics-converter/$resultId/analysis'
      path: '/settlement-statistics-converter/$resultId/analysis'
      fullPath: '/settlement-statistics-converter/$resultId/analysis'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdAnalysisRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/expenditure': {
      id: '/_protected/settlement-statistics-converter/$resultId/expenditure'
      path: '/settlement-statistics-converter/$resultId/expenditure'
      fullPath: '/settlement-statistics-converter/$resultId/expenditure'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdExpenditureRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/revenue': {
      id: '/_protected/settlement-statistics-converter/$resultId/revenue'
      path: '/settlement-statistics-converter/$resultId/revenue'
      fullPath: '/settlement-statistics-converter/$resultId/revenue'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdRevenueRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation': {
      id: '/_protected/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
      path: '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
      fullPath: '/settlement-statistics-converter/$resultId/revenue-axis-revenue-appropriation'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ai-chat/chat/$threadId/': {
      id: '/_protected/ai-chat/chat/$threadId/'
      path: '/chat/$threadId'
      fullPath: '/ai-chat/chat/$threadId/'
      preLoaderRoute: typeof ProtectedAiChatChatThreadIdIndexRouteImport
      parentRoute: typeof ProtectedAiChatRoute
    }
    '/_protected/assessment/$assessmentId/overview/': {
      id: '/_protected/assessment/$assessmentId/overview/'
      path: '/$assessmentId/overview'
      fullPath: '/assessment/$assessmentId/overview/'
      preLoaderRoute: typeof ProtectedAssessmentAssessmentIdOverviewIndexRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/assessment/$assessmentId/overview/edit': {
      id: '/_protected/assessment/$assessmentId/overview/edit'
      path: '/$assessmentId/overview/edit'
      fullPath: '/assessment/$assessmentId/overview/edit'
      preLoaderRoute: typeof ProtectedAssessmentAssessmentIdOverviewEditRouteImport
      parentRoute: typeof ProtectedAssessmentRoute
    }
    '/_protected/projects/ai-matching-results/national-grants/': {
      id: '/_protected/projects/ai-matching-results/national-grants/'
      path: '/national-grants'
      fullPath: '/projects/ai-matching-results/national-grants/'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsNationalGrantsIndexRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/projects/ai-matching-results/prefectural-grants/': {
      id: '/_protected/projects/ai-matching-results/prefectural-grants/'
      path: '/prefectural-grants'
      fullPath: '/projects/ai-matching-results/prefectural-grants/'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/projects/ai-matching-results/special-allocation-tax-survey/': {
      id: '/_protected/projects/ai-matching-results/special-allocation-tax-survey/'
      path: '/special-allocation-tax-survey'
      fullPath: '/projects/ai-matching-results/special-allocation-tax-survey/'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/master/': {
      id: '/_protected/settlement-statistics-converter/$resultId/master/'
      path: '/settlement-statistics-converter/$resultId/master'
      fullPath: '/settlement-statistics-converter/$resultId/master/'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature': {
      id: '/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature'
      path: '/settlement-statistics-converter/$resultId/master/expenditure_nature'
      fullPath: '/settlement-statistics-converter/$resultId/master/expenditure_nature'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose': {
      id: '/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose'
      path: '/settlement-statistics-converter/$resultId/master/revenue_purpose'
      fullPath: '/settlement-statistics-converter/$resultId/master/revenue_purpose'
      preLoaderRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId': {
      id: '/_protected/projects/ai-matching-results/national-grants/$documentId/$recordId'
      path: '/national-grants/$documentId/$recordId'
      fullPath: '/projects/ai-matching-results/national-grants/$documentId/$recordId'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/projects/ai-matching-results/prefectural-grants/$documentId/$recordId': {
      id: '/_protected/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
      path: '/prefectural-grants/$documentId/$recordId'
      fullPath: '/projects/ai-matching-results/prefectural-grants/$documentId/$recordId'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
    '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId': {
      id: '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'
      path: '/special-allocation-tax-survey/$documentId/$recordId'
      fullPath: '/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId'
      preLoaderRoute: typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRouteImport
      parentRoute: typeof ProtectedProjectsAiMatchingResultsRoute
    }
  }
}

interface ProtectedAiChatRouteChildren {
  ProtectedAiChatIndexRoute: typeof ProtectedAiChatIndexRoute
  ProtectedAiChatChatIndexRoute: typeof ProtectedAiChatChatIndexRoute
  ProtectedAiChatChatThreadIdIndexRoute: typeof ProtectedAiChatChatThreadIdIndexRoute
}

const ProtectedAiChatRouteChildren: ProtectedAiChatRouteChildren = {
  ProtectedAiChatIndexRoute: ProtectedAiChatIndexRoute,
  ProtectedAiChatChatIndexRoute: ProtectedAiChatChatIndexRoute,
  ProtectedAiChatChatThreadIdIndexRoute: ProtectedAiChatChatThreadIdIndexRoute,
}

const ProtectedAiChatRouteWithChildren = ProtectedAiChatRoute._addFileChildren(
  ProtectedAiChatRouteChildren,
)

interface ProtectedAssessmentRouteChildren {
  ProtectedAssessmentCreateRoute: typeof ProtectedAssessmentCreateRoute
  ProtectedAssessmentIndexRoute: typeof ProtectedAssessmentIndexRoute
  ProtectedAssessmentAssessmentIdDiffRoute: typeof ProtectedAssessmentAssessmentIdDiffRoute
  ProtectedAssessmentAssessmentIdIndexRoute: typeof ProtectedAssessmentAssessmentIdIndexRoute
  ProtectedAssessmentAssessmentIdOverviewEditRoute: typeof ProtectedAssessmentAssessmentIdOverviewEditRoute
  ProtectedAssessmentAssessmentIdOverviewIndexRoute: typeof ProtectedAssessmentAssessmentIdOverviewIndexRoute
}

const ProtectedAssessmentRouteChildren: ProtectedAssessmentRouteChildren = {
  ProtectedAssessmentCreateRoute: ProtectedAssessmentCreateRoute,
  ProtectedAssessmentIndexRoute: ProtectedAssessmentIndexRoute,
  ProtectedAssessmentAssessmentIdDiffRoute:
    ProtectedAssessmentAssessmentIdDiffRoute,
  ProtectedAssessmentAssessmentIdIndexRoute:
    ProtectedAssessmentAssessmentIdIndexRoute,
  ProtectedAssessmentAssessmentIdOverviewEditRoute:
    ProtectedAssessmentAssessmentIdOverviewEditRoute,
  ProtectedAssessmentAssessmentIdOverviewIndexRoute:
    ProtectedAssessmentAssessmentIdOverviewIndexRoute,
}

const ProtectedAssessmentRouteWithChildren =
  ProtectedAssessmentRoute._addFileChildren(ProtectedAssessmentRouteChildren)

interface ProtectedMasterRouteChildren {
  ProtectedMasterAccountingTypesRoute: typeof ProtectedMasterAccountingTypesRoute
  ProtectedMasterExpenditureItemsRoute: typeof ProtectedMasterExpenditureItemsRoute
  ProtectedMasterOrganizationsRoute: typeof ProtectedMasterOrganizationsRoute
  ProtectedMasterIndexRoute: typeof ProtectedMasterIndexRoute
}

const ProtectedMasterRouteChildren: ProtectedMasterRouteChildren = {
  ProtectedMasterAccountingTypesRoute: ProtectedMasterAccountingTypesRoute,
  ProtectedMasterExpenditureItemsRoute: ProtectedMasterExpenditureItemsRoute,
  ProtectedMasterOrganizationsRoute: ProtectedMasterOrganizationsRoute,
  ProtectedMasterIndexRoute: ProtectedMasterIndexRoute,
}

const ProtectedMasterRouteWithChildren = ProtectedMasterRoute._addFileChildren(
  ProtectedMasterRouteChildren,
)

interface ProtectedProjectsAiMatchingResultsRouteChildren {
  ProtectedProjectsAiMatchingResultsIndexRoute: typeof ProtectedProjectsAiMatchingResultsIndexRoute
  ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute: typeof ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute
  ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute: typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute
  ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute: typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute
  ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute: typeof ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute
  ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute: typeof ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute
  ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute: typeof ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute
}

const ProtectedProjectsAiMatchingResultsRouteChildren: ProtectedProjectsAiMatchingResultsRouteChildren =
  {
    ProtectedProjectsAiMatchingResultsIndexRoute:
      ProtectedProjectsAiMatchingResultsIndexRoute,
    ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute:
      ProtectedProjectsAiMatchingResultsNationalGrantsIndexRoute,
    ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute:
      ProtectedProjectsAiMatchingResultsPrefecturalGrantsIndexRoute,
    ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute:
      ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyIndexRoute,
    ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute:
      ProtectedProjectsAiMatchingResultsNationalGrantsDocumentIdRecordIdRoute,
    ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute:
      ProtectedProjectsAiMatchingResultsPrefecturalGrantsDocumentIdRecordIdRoute,
    ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute:
      ProtectedProjectsAiMatchingResultsSpecialAllocationTaxSurveyDocumentIdRecordIdRoute,
  }

const ProtectedProjectsAiMatchingResultsRouteWithChildren =
  ProtectedProjectsAiMatchingResultsRoute._addFileChildren(
    ProtectedProjectsAiMatchingResultsRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedAiChatRoute: typeof ProtectedAiChatRouteWithChildren
  ProtectedAssessmentRoute: typeof ProtectedAssessmentRouteWithChildren
  ProtectedHomeRoute: typeof ProtectedHomeRoute
  ProtectedMasterRoute: typeof ProtectedMasterRouteWithChildren
  ProtectedPlanUsageRoute: typeof ProtectedPlanUsageRoute
  ProtectedDataImportUploadRoute: typeof ProtectedDataImportUploadRoute
  ProtectedInquiryCompletedRoute: typeof ProtectedInquiryCompletedRoute
  ProtectedJobJobIdRoute: typeof ProtectedJobJobIdRoute
  ProtectedProjectsAiMatchingResultsRoute: typeof ProtectedProjectsAiMatchingResultsRouteWithChildren
  ProtectedProjectsCreateRoute: typeof ProtectedProjectsCreateRoute
  ProtectedSettlementStatisticsConverterCreateRoute: typeof ProtectedSettlementStatisticsConverterCreateRoute
  ProtectedDatConversionIndexRoute: typeof ProtectedDatConversionIndexRoute
  ProtectedDataImportIndexRoute: typeof ProtectedDataImportIndexRoute
  ProtectedInquiryIndexRoute: typeof ProtectedInquiryIndexRoute
  ProtectedJobIndexRoute: typeof ProtectedJobIndexRoute
  ProtectedProjectsIndexRoute: typeof ProtectedProjectsIndexRoute
  ProtectedSettlementStatisticsConverterIndexRoute: typeof ProtectedSettlementStatisticsConverterIndexRoute
  ProtectedUsersIndexRoute: typeof ProtectedUsersIndexRoute
  ProtectedProjectsProjectIdEditRoute: typeof ProtectedProjectsProjectIdEditRoute
  ProtectedProjectsProjectIdMemoRoute: typeof ProtectedProjectsProjectIdMemoRoute
  ProtectedSettlementStatisticsConverterResultIdAnalysisRoute: typeof ProtectedSettlementStatisticsConverterResultIdAnalysisRoute
  ProtectedSettlementStatisticsConverterResultIdExpenditureRoute: typeof ProtectedSettlementStatisticsConverterResultIdExpenditureRoute
  ProtectedSettlementStatisticsConverterResultIdRevenueRoute: typeof ProtectedSettlementStatisticsConverterResultIdRevenueRoute
  ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute: typeof ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute
  ProtectedDataImportImportIdIndexRoute: typeof ProtectedDataImportImportIdIndexRoute
  ProtectedProjectsProjectIdIndexRoute: typeof ProtectedProjectsProjectIdIndexRoute
  ProtectedSettlementStatisticsConverterResultIdIndexRoute: typeof ProtectedSettlementStatisticsConverterResultIdIndexRoute
  ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute
  ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute
  ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute: typeof ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAiChatRoute: ProtectedAiChatRouteWithChildren,
  ProtectedAssessmentRoute: ProtectedAssessmentRouteWithChildren,
  ProtectedHomeRoute: ProtectedHomeRoute,
  ProtectedMasterRoute: ProtectedMasterRouteWithChildren,
  ProtectedPlanUsageRoute: ProtectedPlanUsageRoute,
  ProtectedDataImportUploadRoute: ProtectedDataImportUploadRoute,
  ProtectedInquiryCompletedRoute: ProtectedInquiryCompletedRoute,
  ProtectedJobJobIdRoute: ProtectedJobJobIdRoute,
  ProtectedProjectsAiMatchingResultsRoute:
    ProtectedProjectsAiMatchingResultsRouteWithChildren,
  ProtectedProjectsCreateRoute: ProtectedProjectsCreateRoute,
  ProtectedSettlementStatisticsConverterCreateRoute:
    ProtectedSettlementStatisticsConverterCreateRoute,
  ProtectedDatConversionIndexRoute: ProtectedDatConversionIndexRoute,
  ProtectedDataImportIndexRoute: ProtectedDataImportIndexRoute,
  ProtectedInquiryIndexRoute: ProtectedInquiryIndexRoute,
  ProtectedJobIndexRoute: ProtectedJobIndexRoute,
  ProtectedProjectsIndexRoute: ProtectedProjectsIndexRoute,
  ProtectedSettlementStatisticsConverterIndexRoute:
    ProtectedSettlementStatisticsConverterIndexRoute,
  ProtectedUsersIndexRoute: ProtectedUsersIndexRoute,
  ProtectedProjectsProjectIdEditRoute: ProtectedProjectsProjectIdEditRoute,
  ProtectedProjectsProjectIdMemoRoute: ProtectedProjectsProjectIdMemoRoute,
  ProtectedSettlementStatisticsConverterResultIdAnalysisRoute:
    ProtectedSettlementStatisticsConverterResultIdAnalysisRoute,
  ProtectedSettlementStatisticsConverterResultIdExpenditureRoute:
    ProtectedSettlementStatisticsConverterResultIdExpenditureRoute,
  ProtectedSettlementStatisticsConverterResultIdRevenueRoute:
    ProtectedSettlementStatisticsConverterResultIdRevenueRoute,
  ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute:
    ProtectedSettlementStatisticsConverterResultIdRevenueAxisRevenueAppropriationRoute,
  ProtectedDataImportImportIdIndexRoute: ProtectedDataImportImportIdIndexRoute,
  ProtectedProjectsProjectIdIndexRoute: ProtectedProjectsProjectIdIndexRoute,
  ProtectedSettlementStatisticsConverterResultIdIndexRoute:
    ProtectedSettlementStatisticsConverterResultIdIndexRoute,
  ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute:
    ProtectedSettlementStatisticsConverterResultIdMasterExpenditure_natureRoute,
  ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute:
    ProtectedSettlementStatisticsConverterResultIdMasterRevenue_purposeRoute,
  ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute:
    ProtectedSettlementStatisticsConverterResultIdMasterIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  R404Route: R404Route,
  R500Route: R500Route,
  ProtectedRoute: ProtectedRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
  PasswordResetRoute: PasswordResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
